import React, { useRef } from 'react';
import styled from 'styled-components';
import { Upload } from 'lucide-react';
import { useData } from '../../hooks/useData';
import { isValidFile } from '../../utils/fileTools';
import { ReactComponent as X12Logo } from '../../icons/logo_x12.svg';
import { Button } from '../Styled/components';

const HiddenInput = styled.input`
  display: none;
`;

const MAX_FILE_SIZE = 5000000;

const FileUploadButton = ({style={}}) => {
  const inputRef = useRef();
  const { handleFilesUpload } = useData();

  const handleClick = () => {
    inputRef.current.click();
  };

  const handleChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter(file => isValidFile(file, MAX_FILE_SIZE));
    if (validFiles.length) {
      handleFilesUpload(validFiles);
    } else {
      alert('Invalid file type or size.');
    }
    e.target.value = '';
  };

  return (
    <Button onClick={handleClick} type="button" style={style}>
      <Upload size={18} /> Upload
      <X12Logo style={{ width: '24px', height: '24px' }} />
      <HiddenInput
        ref={inputRef}
        type="file"
        multiple
        onChange={handleChange}
      />
    </Button>
  );
};

export default FileUploadButton;